import React from "react";

const DisplayPropertyWithEdit = ({ editable, label, value, onChange }) => {
  return (
    <div className="w-full mt-2">
      <div className="flex flex-col sm:flex-row w-full items-start">
        <div className="text-base font-semibold">
          <span>{label}: </span>
        </div>
        <div
          className="text-base sm:pl-3 mt-0"
          style={{ whiteSpace: "pre-wrap",  wordBreak: "break-word" }}
        >
          {value}
        </div>
      </div>
    </div>
  );
};

export default DisplayPropertyWithEdit;
